import {
  getToken,
  getMessaging,
  isSupported,
  Messaging,
} from 'firebase/messaging';
import { useEffect, useRef, useState } from 'react';
import { vapidConfig } from '../../Firebase/configs';

const usePushRegistration = () => {
  const [token, setToken] = useState('');

  const messagingRef = useRef<Messaging | null>(null);

  useEffect(() => {
    isSupported().then(() => {
      messagingRef.current = getMessaging();
    });
  }, []);

  useEffect(() => {
    if (messagingRef.current) {
      getToken(messagingRef.current, vapidConfig)
        .then((currentToken) => {
          if (currentToken) {
            setToken(currentToken);
          }
        })
        .catch((err) => {
          console.log('An error occurred while retrieving token. ', err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messagingRef.current]);

  return { token };
};

export default usePushRegistration;
